var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTypeEyeSizesWeightfilled = function SvgTypeEyeSizesWeightfilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#343330",
    d: "M19.321 9.747c-.027-.062-.689-1.53-2.16-3C15.2 4.785 12.725 3.75 10 3.75S4.8 4.786 2.84 6.746C1.367 8.217.702 9.687.678 9.746a.63.63 0 0 0 0 .509c.027.061.689 1.529 2.16 3 1.96 1.96 4.436 2.995 7.161 2.995s5.2-1.036 7.16-2.995c1.472-1.471 2.134-2.939 2.161-3a.63.63 0 0 0 0-.508M10 13.125a3.125 3.125 0 1 1 0-6.25 3.125 3.125 0 0 1 0 6.25"
  })));
};
export default SvgTypeEyeSizesWeightfilled;